<template><div><h1 id="weitere-quellen" tabindex="-1"><a class="header-anchor" href="#weitere-quellen"><span>Weitere Quellen</span></a></h1>
<p>Weitere Quellen — Erträge, die einem Projekt manuell oder über Aktionen zugeordnet werden.</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Unter weitere Quellen&quot; werden pro Jahr manuell beliebige Erträge zu <RouteLink to="/referenz/refs/ft.refdata.projekte.html" title="Projekte">Projekten</RouteLink> erfasst oder und die Beträge aus <RouteLink to="/referenz/refs/ft.refdata.aktionen.html" title="Aktionen">Aktionen</RouteLink> abgebildet.</p>
<p>Pfad: <code v-pre>Projektfinanzierung → Projekte</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Periode</dt>
<dd>Jahr resp. Geschäftsjahr.</dd>
<dt>Datum</dt>
<dd>Datum des Zahlungseingangs er Quelle (Info).</dd>
<dt>Typ</dt>
<dd>Aktion = Zahlung, abgebildet in einer <a class="link" href="ft.refdata.aktionen.html" title="Aktionen">Aktion</a>. Diese Datensätze werden automatisch durch das System erfasst wenn der <a class="link" href="ft.refdata.aktionscodes.html" title="Aktionen Stammdaten">Aktionscode</a> der Aktion mit einem &quot;+&quot; unter &quot;Umsatz w. Quellen&quot; eingetragen ist.<br>manuell = wird automatisch gesetzt bei einer manuellen Erfassung.</dd>
<dt>Betrag</dt>
<dd>Betrag in Hauswährung</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.aktionen.html" title="Aktionen">Aktion</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.projekte.html" title="Projekte">Projekte</RouteLink></p>
</div></template>


